import styled from "styled-components";

export const FestivalCompetitionsBannerWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const FestivalCompetitionsBannerSwiper = styled.div`
  width: 100%;
  position: relative;
  height: 324px;

  > .back {
    width: 100%;
    height: 324px;
    top: 0;
    position: absolute;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0) 51.08%,
      #121212 85.49%
    );
  }

  > img {
    width: 100%;
    height: 324px;
    object-fit: cover;
  }
`;

export const FestivalCompetitionsBannerSwiperText = styled.div`
  position: absolute;
  bottom: 49px;
  left: 16px;
  color: #fff;
  display: flex;
  flex-direction: column;

  > .title {
    font-family: Optien;
    font-weight: 900;
    font-size: 32px;
  }

  > .subTitle {
    font-weight: 400;
    font-size: 16px;
  }
`;

export const FestivalCompetitionsBannerProgress = styled.div<{
  currenIndex: number;
  width: number;
}>`
  position: absolute;
  z-index: 10;
  bottom: 24px;
  left: 16px;
  width: calc(100% - 32px);

  display: flex;
  height: 5px;

  > .bar {
    background: #ffffff80;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  > .background {
    position: absolute;
    left: ${({ currenIndex, width }) => currenIndex * width}%;
    width: ${({ width }) => width}%;
    height: 5px;
    background: #ffffffcc;
    z-index: 0;
    transition: left 0.5s ease;
  }

  > .dot {
    height: 100%;
    flex: 1;
  }
`;
